import React from 'react';

// from https://github.com/qiaolb/react-dragscroll/blob/master/src/DragScroll.jsx
// qiaolb 进行空判断
// but enhanced with possibility to allow scrolling only in X direction and disabling scrolling altogether

export default class DragScroll extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.dataSource,
      dragging: false
    };
  }

  render() {
    const style = { style: { ...this.props.style, overflowX: 'auto', overflowY: this.props.onlyX ? 'hidden' : 'auto' } };
    return <div className={this.props.className} {...style}
      onMouseUp={this.mouseUpHandle.bind(this)}
      onMouseMove={this.mouseMoveHandle.bind(this)}
      ref="container">
      {this.props.children && this.renderChildren(this.props.children)}
    </div>;
  }

  componentDidMount() {
    window.addEventListener('mouseup', this.mouseUpHandle.bind(this));
    window.addEventListener('mousemove', this.mouseMoveHandle.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener('mouseup', this.mouseUpHandle.bind(this));
    window.removeEventListener('mousemove', this.mouseMoveHandle.bind(this));
  }

  mouseUpHandle(e) {
    const { disabled } = this.props;
    if (disabled) {
      return;
    }
    if (this.state.dragging) {
      this.setState({
        dragging: false
      });
    }
  }

  mouseDownHandle(e) {
    const { disabled } = this.props;
    if (disabled) {
      return;
    }
    if (!this.state.dragging) {
      this.setState({
        dragging: true
      });
      this.lastClientX = e.clientX;
      this.lastClientY = e.clientY;
      e.preventDefault();
    }
  }

  mouseMoveHandle(e) {
    const { disabled, onlyX } = this.props;
    if (disabled) {
      return;
    }

    this.lastClientY = e.clientY;
    if (this.state.dragging) {
      this.refs.container.scrollLeft -=
        (-this.lastClientX + (this.lastClientX = e.clientX));

      if(!onlyX) {
        this.refs.container.scrollTop -=
            (-this.lastClientY + (this.lastClientY = e.clientY));
      }
    }
  }

  renderChildren(dom, type) {
    if (this.isArray(dom)) {
      return dom.map((item, index) => {
        return React.cloneElement(item, {
          key: item.key || index,
          onMouseUp: this.mouseUpHandle.bind(this),
          onMouseDown: this.mouseDownHandle.bind(this)
        });
      });
    } else if ('object' === typeof dom) {
      return React.cloneElement(dom, {
        onMouseUp: this.mouseUpHandle.bind(this),
        onMouseDown: this.mouseDownHandle.bind(this)
      });
    }
  }

  isArray(object){
    return  object && typeof object==='object' &&
      typeof object.length==='number' &&
      typeof object.splice==='function' &&

      !(object.propertyIsEnumerable('length'));
  }
}